export const thunkTypes = {
  LIST_TOPICS: `education/listTopics`,
  MARK_TOPIC: `education/markTopic`,
  UNMARK_TOPIC: `education/unmarkTopic`,
  COMPLETE_TRAINING: `education/completeTraining`,
};
